<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("unitofmeasurement", 2) }}
      </div>
      <router-link class="btn-blue" to="unit-of-measurment"
        >{{ $tc("unitofmeasurement", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="uom_unit"
                name="uom"
                id="uom"
                v-validate="'required|alpha_spaces'"
              />
              <label>{{ $tc("unitofmeasurement", 2) }}</label>
            </div>
            <!-- <Tooltip :title="$t('unitofmeasurement_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('uom')">{{
              errors.first("uom")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="uom_short_form2"
                name="shortform"
                id="shortform"
                v-validate="'required|alpha_spaces'"
              />
              <label>{{ $t("Short Form") }}</label>
            </div>
            <!-- <Tooltip :title="$t('uomshortform')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('shortform')">{{
              errors.first("shortform")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                id="desc"
                type="text"
                name="desc"
                v-model="uom_description"
                v-validate="'required|alpha_spaces'"
              />
              <label>{{ $t("description") }}</label>
            </div>
            <!-- <Tooltip :title="$t('uom_description')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('desc')">{{
              errors.first("desc")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("hasparent") }}</label>
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="is_parent"
              type="checkbox"
              class="j-checkbox"
              checked
            />
            <!-- <span class="switch-slider"></span>
            </label> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3" v-if="is_parent">
          <!-- <label class="mb-0 mr-3">{{ $t('parent') }}</label> -->
          <div class="dropdown-curve-container">
            <label :class="fc_parent_label ? 'shift-up' : ''">{{
              $t("parent")
            }}</label>
            <b-dropdown
              :text="fc_parent_label"
              variant="dropdown-curve"
              class="w-100"
            >
              <b-dropdown-item
                v-for="(fc, fcIndex) in ms_unit_of_measurement"
                :key="fcIndex"
                href="#"
                :disabled="fc.uom_unit == uom_unit"
                @click="
                  uom_parent_id = fc.uom_id;
                  fc_parent_label = fc.uom_unit;
                  uom_short_form = '=1' + fc.uom_short_form;
                "
                name="selectparent"
                id="selectparent"
                >{{ fc.uom_unit }}</b-dropdown-item
              >
              <!-- <b-dropdown-item href="#">unit 1</b-dropdown-item>
                <b-dropdown-item href="#">unit 2</b-dropdown-item>
                <b-dropdown-item href="#">unit 3</b-dropdown-item>
            <b-dropdown-item href="#">unit4</b-dropdown-item>-->
              <!-- <b-dropdown-item href="#" v-for="(loop , key) in 20" :key="key">Something else here</b-dropdown-item> -->
            </b-dropdown>
            <!-- <Tooltip :title="$t('uom_parent_tooltip')" /> -->
            <!-- <span class="icon-question" v-b-tooltip.hover.top="$t('uom_parent_tooltip')"></span> -->
            <p class="error_message">
              <span v-if="submitted && fc_parent_label == ''">{{
                messageparent
              }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3" v-if="is_parent">
          <div class="d-flex justify-content-center align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="uom_formula"
                name="formula"
                id="formula"
                v-validate="'required|numeric'"
                step="any"
              />
              <label class="mb-0">{{ $t("formula") }}</label>
            </div>
            <input class="formula_css" v-model="uom_short_form" />
            <!-- <Tooltip :title="$t('uom_description')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('formula')">{{
              errors.first("formula")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <!-- <label class="ios-switch"> -->
            <b-form-checkbox
              v-model="uom_is_active"
              type="checkbox"
              class="j-checkbox"
            />
            <!-- <span class="switch-slider"></span>
            </label> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="onFinalSubmit(true)" class="btn-blue">
            {{ $t("save") }}
          </button>
          <button @click.prevent.stop="onFinalSubmit(false)" class="btn-blue">
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="unit-of-measurment"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import MasterService from "@/services/MasterService";
//import PosFnbService from "@/services/MasterService";
export default {
  components: { Multiselect },
  data() {
    return {
      messageparent: "Please Select Parent.",
      uom_unit: "",
      uom_short_form: "",
      uom_short_form2: "",
      submitted: false,
      uom_formula: "",
      uom_parent_id: "",
      uom_description: "",
      uom_is_active: true,
      inshort: "",
      inshortvalue: "",
      fc_parent_id: 0,
      fc_parent_label: "",
      fc_is_active: true,
      is_parent: false,
      detailss: "",
    };
  },
  mounted() {
    this.getVendorsList();
  },
  methods: {
    getVendorsList: function () {
      let payload = {
        tableName: "ms_unit_of_measurement",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ms_unit_of_measurement = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onResetForm: function () {
      (this.uom_short_form2 = ""), (this.uom_unit = "");
      this.uom_short_form = "";
      this.uom_id = "";
      this.fc_parent_id = 0;
      this.fc_parent_label = "";
      this.uom_formula = "";
      this.uom_description = "";
      this.is_parent = false;
      this.uom_is_active = true;
    },
    onFinalSubmit(flag) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (valid) {
          if (this.uom_unit.length > 0) {
            let payload = {
              uom_unit: this.uom_unit,
              uom_short_form: this.uom_short_form2,
              uom_formula: this.uom_formula,
              uom_parent_id: this.uom_parent_id,
              uom_description: this.uom_description,
              uom_is_active: this.uom_is_active,
            };
            MasterService.AddUnitOfMeasurement(payload)
              .then((response) => {
                const { data } = response;
                if (data && data.status) {
                  this.onResetForm();
                  if (flag) {
                    this.$toasted.show(data.message);
                    this.$router.push({
                      path: "/master/unit-of-measurment",
                    });
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch((err) => {
                this.$toasted.show(err);
              });
          }
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/UnitofMesurementComponents/addUnitOfMeasurement.vue